import { createContext } from "react";

export const DetailsAsideViewportOffsetContext = createContext<
    number | undefined
>(undefined);
